import { Checkbox as BCheckbox } from '@base-ui/react/checkbox'
import clsx from 'clsx'
import type React from 'react'

export interface CheckboxProps
  extends Pick<
    React.InputHTMLAttributes<HTMLInputElement>,
    'className' | 'disabled' | 'id' | 'name' | 'tabIndex' | 'aria-hidden'
  > {
  checked?: boolean
  defaultChecked?: boolean
  onChange?: (checked: boolean) => void
  indeterminate?: boolean
  value?: string
}

function CheckIcon(props: React.ComponentProps<'svg'>) {
  return (
    <svg
      fill="currentColor"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      aria-hidden="true"
      {...props}
    >
      <path
        d="M10.5 2.5L4.5 8.5L1.5 5.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  )
}

export function Checkbox({
  className,
  checked,
  defaultChecked,
  onChange,
  indeterminate,
  id,
  ...props
}: CheckboxProps) {
  return (
    <BCheckbox.Root
      checked={checked}
      defaultChecked={defaultChecked}
      onCheckedChange={onChange}
      indeterminate={indeterminate}
      id={id}
      className={clsx(
        // Base styles
        'flex items-center justify-center w-4 h-4 shrink-0 rounded border-2 transition-all duration-200',
        'focus:outline-none focus:ring-2 focus:ring-lavender focus:ring-offset-2',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        // Unchecked state
        'border-gray-stroke bg-white',
        // Checked state
        'data-[checked]:bg-forest data-[checked]:border-forest',
        // Indeterminate state
        'data-[indeterminate]:bg-forest data-[indeterminate]:border-forest',
        className
      )}
      {...props}
    >
      <BCheckbox.Indicator
        className={clsx(
          'text-white transition-opacity duration-200',
          'data-[unchecked]:opacity-0 data-[checked]:opacity-100',
          'data-[indeterminate]:opacity-100'
        )}
      >
        {indeterminate ? <div className="w-2 h-0.5 bg-white rounded" /> : <CheckIcon />}
      </BCheckbox.Indicator>
    </BCheckbox.Root>
  )
}
